module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/array-buffer-native.js
// module id = 422
// module chunks = 0 1 5